import { render, staticRenderFns } from "./CRM.vue?vue&type=template&id=fe3b2d18&"
import script from "./CRM.vue?vue&type=script&lang=js&"
export * from "./CRM.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports